import React from 'react';

import { useIntl } from '../../../../util/reactIntl';

import css from './TopbarNotice.module.css';

// Local kill-switch for the announcement bar. Flip to `true` to bring
// back "Gratis frakt på ditt første kjøp" (or whatever marketing copy
// the `Topbar.noticeText` translation key currently carries). Kept as
// an in-file constant rather than an env var so toggling doesn't
// require a rebuild — the constant is read at component render time.
const SHOW_TOPBAR_NOTICE = false;

/**
 * Black announcement bar rendered above the topbar on every page.
 *
 * The visible text is translatable (`Topbar.noticeText`). When marketing
 * needs to swap the message for a campaign, it's a one-key change in
 * en.json / nb.json.
 *
 * @returns {JSX.Element|null} The bar, or `null` while it's locally
 *   disabled via `SHOW_TOPBAR_NOTICE` above.
 */
const TopbarNotice = () => {
  const intl = useIntl();

  if (!SHOW_TOPBAR_NOTICE) {
    return null;
  }

  return (
    <div className={css.root} role="status" aria-live="polite">
      <p className={css.text}>{intl.formatMessage({ id: 'Topbar.noticeText' })}</p>
    </div>
  );
};

export default TopbarNotice;
